export type FBPages = {
  data: {
    access_token: string
    category: string
    category_list: [{ id: string; name: string }]
    id: string
    name: string
    tasks: string[]
  }[]
}

export const FBRequiredScoeps = [
  'instagram_basic',
  'pages_show_list',
  'instagram_manage_insights',
  'pages_read_engagement',
  'instagram_content_publish',
  'business_management',
] as const

export const getFacebookPages = async (fbAccessToken: string) => {
  const res = await fetch(`https://graph.facebook.com/me/accounts?access_token=${fbAccessToken}`)
  const fbRes: FBPages = await res.json()
  return fbRes
}

type InstagramBusinessAccount = {
  id: string
  instagram_business_account?: {
    id: string
  }
}

/**
 * @see https://developers.facebook.com/docs/instagram-api/reference/page?locale=ja_JP
 */
const getIGBusinessAccountUid = async (fbPageId: string, token: string) => {
  const uid = await fetch(
    `https://graph.facebook.com/${fbPageId}?fields=instagram_business_account&access_token=${token}`,
  )
    .then((res) => res.json())
    .then((igData: InstagramBusinessAccount) => {
      return igData.instagram_business_account?.id
    })
  return uid
}

type InstagramUser = {
  id: string
  name: string
  username: string
  followers_count: number
  profile_picture_url?: string
}

/**
 * @see https://developers.facebook.com/docs/instagram-api/reference/ig-user
 */
const getIGUser = async (uid: string, accessToken: string) => {
  const res = await fetch(
    `https://graph.facebook.com/${uid}?fields=name,profile_picture_url,username,followers_count&access_token=${accessToken}`,
  )
  const data: InstagramUser = await res.json()
  return data
}

export type FBPageAndIGUser = {
  fbPage: FBPages['data'][number]
  igUser: InstagramUser
}

export const getFacebookAndIGUser = async (fbPages: FBPages, token: string): Promise<FBPageAndIGUser[]> => {
  const data = await Promise.all(
    fbPages.data.map(async (fbPage) => {
      const uid = await getIGBusinessAccountUid(fbPage.id, token)

      if (!uid) return
      const igUser = await getIGUser(uid, token)

      return {
        fbPage,
        igUser,
      }
    }),
  )
  return data.filter((x): x is FBPageAndIGUser => !!x)
}
